<template>
  <div :id="`${inputId}-label`" :class="['form-label', { required: required }]">{{ label }}</div>
  <slot :state="state"
        :updateState="updateState"
        :required="required"
        :inputId="inputId"
        :aria-labelledby="`${inputId}-label`"
        :aria-describedby="`${inputId}-error`"></slot>
  <div v-if="state && !showWarning" class="text-danger" role="alert" :id="`${inputId}-error`">{{ errorMessage }}</div>
  <div v-if="state && showWarning" class="mdh-text-warning" role="alert" :id="`${inputId}-warning`">{{ errorMessage }}</div>
  <div v-else-if="hint" class="hint ms-2 mt-1" :id="`${inputId}-hint`">{{ hint }}</div>
</template>
  
  <script setup>
  // ===============================
  // IMPORTS
  // ===============================
  // Vue Core
  
  // Components
  
  // Composables
  
  // Stores
  
  // Constants and Utils
  
  // ===============================
  // PROPS & EMITS
  // ===============================
  defineProps({
    inputId: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    state: {
      type: Boolean,
      required: true
    },
    errorMessage: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    showWarning: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    },
  });

  const emit = defineEmits(['update:state']);
  
  const updateState = (value) => {
      emit('update:state', value);
  };

  // ===============================
  // COMPOSABLES & STORES
  // ===============================
  
  // ===============================
  // REACTIVE STATE
  // ===============================
  
  // ===============================
  // CONSTANTS
  // ===============================
  
  // ===============================
  // COMPUTED PROPERTIES
  // ===============================
  
  // ===============================
  // METHODS
  // ===============================
  
  // ===============================
  // WATCHERS
  // ===============================
  
  // ===============================
  // LIFECYCLE HOOKS
  // ===============================
  
  // ===============================
  // EXPOSE
  // ===============================
  
  </script>